import React from "react";
import { SubscriptionState } from "subscription/subscriptionState";
import { any, fromJSX, StandardLocalWidget } from "widgets-for-react";
import SuccessUpgradeSubscriptionLayout from "./successUpgradeSubscriptionLayout";

const successUpgradeSubscriptionWidget = ():
    StandardLocalWidget<SubscriptionState> =>
    (subscriptionState: SubscriptionState) =>
    any([
        fromJSX((setState) => {
            return (
                <SuccessUpgradeSubscriptionLayout
                    userSubscriptionState={subscriptionState.userSubscriptions}
                    onUserSubscriptionStateChange={(newState) => {                       
                        setState(currentState => ({...currentState, userSubscriptions: newState}))
                    }}/>
            )
        })
    ]
)

export default successUpgradeSubscriptionWidget
